
import { Component, Prop, Vue } from 'vue-property-decorator';
import InquiryRequestListItem from '@/components/inquiries/InquiryRequestListItem.vue';
import PaginationControls from '@/components/shared/suites/PaginationControls.vue';

@Component<InquiryRequestList>({
	components: {
		InquiryRequestListItem,
		PaginationControls
	}
})
export default class InquiryRequestList extends Vue {
	@Prop({ type: Array, required: true }) private requests!: InquiryFormRequest[];
	@Prop({ type: Object, required: false, default: null }) private selectedRequest!: InquiryFormRequest | null;
	@Prop({ type: Number, required: true }) private currentPage!: number;
	@Prop({ type: Number, required: true }) private totalPages!: number;
	@Prop({ type: Boolean, default: false }) private loading!: boolean;
}
